/* BAF Saat — ürün karşılaştırma (eski temadaki baf-compare.js mantığı, yeni sınıflarla).
   Seçim tarayıcıda saklanır (en çok 4 tutamaç). Ürün verisi ?view=bs-karsilastir-veri ile JSON gelir; metafield'ı
   boş özellikler açıklamadaki tedarikçi tablosundan okunur (HTML sayfaya basılmaz, yalnız metin alınır). */
(() => {
  const kok = document.getElementById('BsKarsilastir');
  if (!kok || kok.dataset.hazir) return;
  kok.dataset.hazir = 'true';
  const ANAHTAR = 'bs-karsilastir-v1';
  const root = kok.dataset.root || '/';
  const ara = kok.dataset.search || '/search';
  const pencere = kok.querySelector('dialog');
  const yuvalar = kok.querySelector('[data-compare-slots]');
  const durum = kok.querySelector('[data-compare-status]');
  const girdi = kok.querySelector('[data-compare-input]');
  const sonuclar = kok.querySelector('[data-compare-results]');
  const sayfa = document.querySelector('[data-compare-page]');
  /* Metinler: snippets/bs-karsilastir.liquid içindeki #BsKarMetinler (dil dosyasından). Yoksa Türkçe yedek kalır. */
  const M = {
    kayit_yok: 'Tarayıcı kaydı kullanılamıyor; seçiminiz bu sayfada korunur.',
    zaten_listede: 'Bu saat karşılaştırma listenizde.',
    en_fazla: 'En fazla 4 saat karşılaştırabilirsiniz. Yeni saat için birini çıkarın.',
    eklendi: 'Saat karşılaştırmaya eklendi.',
    konum_bir: '1 saat',
    konum: '{n} saat',
    konum_kaydir: '{n} saat · yana kaydırın',
    en_az_iki: 'Karşılaştırmak için en az 2 saat seçin.',
    belirtilmemis: 'Belirtilmemiş özellikler “—” ile gösterilir.',
    tablodan_cikar: 'Saati karşılaştırmadan çıkar',
    stokta_yok: 'STOKTA YOK',
    urun_yuklenemedi: 'Bu ürünün bilgileri yüklenemedi.',
    yeniden_dene: 'Yeniden dene',
    listeden_cikar: 'Saati listeden çıkar',
    tum_saatlerden: 'Tüm saatlerden ürün ekle',
    yuklenemedi: 'Yüklenemedi',
    yeniden_yukle: 'Yeniden yükle',
    saat: 'Saat',
    cikar_ad: '{ad} — çıkar',
    temizlendi: 'Karşılaştırma listesi temizlendi.',
    en_az_karakter: 'Aramak için en az 2 karakter yazın.',
    araniyor: 'Aranıyor…',
    secin: 'Eklemek istediğiniz saati seçin.',
    bulunamadi: 'Bu aramada saat bulunamadı.',
    arama_hatasi: 'Arama yüklenemedi. Lütfen tekrar deneyin.',
    ozellik: 'Özellik',
    yukleniyor: 'Yükleniyor…',
    sepete_ekle: 'SEPETE EKLE',
    etiketler: { cinsiyet: 'Cinsiyet', mekanizma: 'Mekanizma', kasa_capi: 'Kasa çapı', kasa_materyali: 'Kasa materyali', kasa_rengi: 'Kasa rengi', kadran_rengi: 'Kadran rengi', kordon_materyali: 'Kordon materyali', kordon_rengi: 'Kordon rengi', suya_dayaniklilik: 'Suya dayanıklılık', cam_tipi: 'Cam tipi', kasa_sekli: 'Kasa şekli', takvim: 'Takvim', agirlik: 'Ağırlık', kasa_kalinligi: 'Kasa kalınlığı', gosterim_tipi: 'Gösterim tipi', kronometre: 'Kronometre', alarm: 'Alarm' },
  };
  try {
    /* Liquid `t` çıktısı HTML kaçışlı gelir (&#39; gibi); metin olarak çöz */
    const coz = (s) => { const d = document.createElement('textarea'); d.innerHTML = String(s); return d.value; };
    const gelen = JSON.parse(document.getElementById('BsKarMetinler')?.textContent || '{}');
    Object.entries(gelen).forEach(([k, v]) => {
      if (v && typeof v === 'object') Object.entries(v).forEach(([a, b]) => { if (b) M[k][a] = coz(b); });
      else if (typeof v === 'string' && v) M[k] = coz(v);
    });
  } catch { /* Türkçe yedek kalır */ }
  const gecerli = (h) => typeof h === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(h);
  const temizle = (a) => (Array.isArray(a) ? [...new Set(a.filter(gecerli))].slice(0, 4) : []);
  let secili = [];
  let acan;
  let zamanlayici;
  let aramaKontrol;
  let surum = 0;
  try { secili = temizle(JSON.parse(localStorage.getItem(ANAHTAR) || '[]')); } catch { /* depolama isteğe bağlı */ }
  const params = new URLSearchParams(location.search);
  if (sayfa && params.has('compare')) secili = temizle(params.get('compare').split(','));

  const ETIKETLER = M.etiketler;
  const ESLER = { 'kullanım grubu': 'cinsiyet', cinsiyet: 'cinsiyet', mekanizma: 'mekanizma', 'mekanizma tipi': 'mekanizma', 'çalışma şekli': 'mekanizma', 'makine cinsi': 'mekanizma', 'kasa çapı': 'kasa_capi', 'kasa ölçüsü': 'kasa_capi', 'kasa boyutu': 'kasa_capi', 'kasa materyali': 'kasa_materyali', 'kasa malzemesi': 'kasa_materyali', 'kasa rengi': 'kasa_rengi', 'kadran rengi': 'kadran_rengi', 'kordon materyali': 'kordon_materyali', 'kordon malzemesi': 'kordon_materyali', 'kordon / bilezik': 'kordon_materyali', 'kordon cinsi': 'kordon_materyali', 'kordon rengi': 'kordon_rengi', 'suya dayanıklılık': 'suya_dayaniklilik', 'su geçirmezlik': 'suya_dayaniklilik', cam: 'cam_tipi', 'cam tipi': 'cam_tipi', 'cam özellik': 'cam_tipi', 'kasa şekli': 'kasa_sekli', takvim: 'takvim', ağırlık: 'agirlik', 'kasa kalınlığı': 'kasa_kalinligi', kronometre: 'kronometre', alarm: 'alarm', 'gösterim tipi': 'gosterim_tipi' };

  const zenginlestir = (p) => {
    const doc = new DOMParser().parseFromString(p.description || '', 'text/html');
    doc.querySelectorAll('tr').forEach((satir) => {
      const h = satir.querySelectorAll('th,td');
      if (h.length !== 2) return;
      const ad = h[0].textContent.trim().toLocaleLowerCase('tr-TR').replace(/:$/, '');
      const k = ESLER[ad];
      const v = h[1].textContent.trim();
      if (k && !p.specs[k] && v) p.specs[k] = v;
    });
    return p;
  };
  const onbellek = new Map();
  const el = (etiket, metin, sinif) => { const n = document.createElement(etiket); if (metin) n.textContent = metin; if (sinif) n.className = sinif; return n; };
  const dugme = (metin, is, etiket, sinif) => { const n = el('button', metin, sinif); n.type = 'button'; if (etiket) n.setAttribute('aria-label', etiket); n.addEventListener('click', is); return n; };
  const gorsel = (p) => { const n = el('img'); if (p.image) n.src = p.image; n.alt = p.title; n.width = 160; n.height = 200; n.loading = 'lazy'; return n; };
  const adres = () => `${ara}?view=bs-karsilastir&compare=${encodeURIComponent(secili.join(','))}`;
  const urun = async (h) => {
    if (onbellek.has(h)) return onbellek.get(h);
    const r = await fetch(`${root}products/${encodeURIComponent(h)}?view=bs-karsilastir-veri`, { credentials: 'same-origin' });
    if (!r.ok) throw Error('urun');
    const p = await r.json();
    if (p.handle !== h || !p.title || !p.specs) throw Error('urun');
    zenginlestir(p); onbellek.set(h, p); return p;
  };
  const kaydet = () => {
    try { localStorage.setItem(ANAHTAR, JSON.stringify(secili)); } catch { durum.textContent = M.kayit_yok; }
    if (sayfa) history.replaceState(null, '', adres());
  };
  const cikar = (h) => { secili = secili.filter((v) => v !== h); kaydet(); ciz(); };
  const ekle = (h) => {
    if (!gecerli(h)) return;
    if (secili.includes(h)) { durum.textContent = M.zaten_listede; return; }
    if (secili.length >= 4) { durum.textContent = M.en_fazla; return; }
    secili.push(h); kaydet(); ciz(); durum.textContent = M.eklendi;
  };

  /* ——— Tablo sayfası ——— */
  const sar = sayfa?.querySelector('[data-compare-wrap]');
  const okDurumu = () => {
    if (!sayfa) return;
    const max = sar.scrollWidth - sar.clientWidth;
    sayfa.querySelector('[data-compare-prev]').disabled = sar.scrollLeft <= 2;
    sayfa.querySelector('[data-compare-next]').disabled = sar.scrollLeft >= max - 2;
    const n = sayfa.querySelectorAll('thead td').length;
    sayfa.querySelector('[data-compare-position]').textContent = n > 2 && max > 2 ? M.konum_kaydir.replace('{n}', n) : (n === 1 ? M.konum_bir : M.konum.replace('{n}', n));
  };
  if (sayfa) {
    const azHareket = matchMedia('(prefers-reduced-motion: reduce)').matches;
    [['[data-compare-prev]', -1], ['[data-compare-next]', 1]].forEach(([s, yon]) => sayfa.querySelector(s).addEventListener('click', () => sar.scrollBy({ left: (yon * sar.clientWidth) / 2, behavior: azHareket ? 'instant' : 'smooth' })));
    sar.addEventListener('scroll', okDurumu, { passive: true });
    new ResizeObserver(okDurumu).observe(sar);
  }
  const farklar = () => { if (sayfa) sayfa.querySelectorAll('tbody tr').forEach((s) => { s.hidden = sayfa.querySelector('[data-compare-diff]').checked && s.dataset.farkli !== 'true'; }); };
  const tablo = (liste) => {
    const t = sayfa.querySelector('table');
    t.replaceChildren();
    const bilgi = sayfa.querySelector('[data-compare-page-status]');
    if (liste.length < 2) { bilgi.textContent = M.en_az_iki; okDurumu(); return; }
    bilgi.textContent = M.belirtilmemis;
    t.style.minWidth = `${160 + liste.length * 230}px`;
    const bas = el('thead');
    const ust = el('tr');
    ust.append(el('th', M.ozellik));
    liste.forEach(({ h, p }) => {
      const hucre = el('td');
      hucre.append(dugme('×', () => cikar(h), M.tablodan_cikar, 'bs-kar-sayfa__cikar'));
      if (p) {
        const a = el('a', null, 'bs-kar-sayfa__urun'); a.href = p.url;
        a.append(gorsel(p), el('span', (p.vendor || '').toLocaleUpperCase('tr-TR'), 'bs-ust'), el('span', p.title, 'bs-kar-sayfa__ad'));
        hucre.append(a, el('span', p.sku || '', 'bs-kod'), el('strong', p.price, 'bs-fiyat'));
        const form = el('form'); form.method = 'post'; form.action = `${root}cart/add`;
        const id = el('input'); id.type = 'hidden'; id.name = 'id'; id.value = p.variant;
        const al = el('button', p.available ? M.sepete_ekle : M.stokta_yok, 'bs-btn bs-btn--birincil'); al.type = 'submit'; al.disabled = !p.available;
        form.append(id, al); hucre.append(form);
      } else {
        hucre.append(el('p', M.urun_yuklenemedi, 'bs-kucuk'), dugme(M.yeniden_dene, () => ciz(), null, 'bs-cip'));
      }
      ust.append(hucre);
    });
    bas.append(ust); t.append(bas);
    const govde = el('tbody');
    Object.entries(ETIKETLER).forEach(([k, etiket]) => {
      const degerler = liste.map(({ p }) => p?.specs[k]?.trim() || '—');
      if (degerler.every((v) => v === '—')) return;
      const s = el('tr'); s.dataset.farkli = String(new Set(degerler).size > 1);
      const th = el('th', etiket); th.scope = 'row'; s.append(th);
      degerler.forEach((v) => s.append(el('td', v)));
      govde.append(s);
    });
    t.append(govde); farklar(); requestAnimationFrame(okDurumu);
  };

  /* ——— Seçici ——— */
  const ciz = async () => {
    const r = ++surum;
    kok.querySelectorAll('[data-compare-count]').forEach((n) => { n.textContent = `${secili.length}/4`; });
    kok.querySelector('.bs-kar__acici').hidden = !secili.length || Boolean(sayfa);
    const git = kok.querySelector('[data-compare-go]');
    git.setAttribute('aria-disabled', String(secili.length < 2));
    if (secili.length >= 2) git.href = adres(); else git.removeAttribute('href');
    yuvalar.replaceChildren();
    const liste = [...secili];
    liste.forEach((h) => { const y = el('div', null, 'bs-kar__yuva'); y.append(el('span', M.yukleniyor, 'bs-kucuk'), dugme('×', () => cikar(h), M.listeden_cikar, 'bs-kar__cikar')); yuvalar.append(y); });
    for (let i = liste.length; i < 4; i++) { const bos = el('a', '+', 'bs-kar__yuva bs-kar__yuva--bos'); bos.href = kok.dataset.all || `${root}collections/all`; bos.setAttribute('aria-label', M.tum_saatlerden); yuvalar.append(bos); }
    const urunler = await Promise.all(liste.map(async (h) => { try { return { h, p: await urun(h) }; } catch { return { h, p: null }; } }));
    if (r !== surum) return;
    urunler.forEach(({ h, p }, i) => {
      const y = yuvalar.children[i]; y.replaceChildren();
      if (p) y.append(gorsel(p), el('span', p.title, 'bs-kucuk'));
      else y.append(el('span', M.yuklenemedi, 'bs-kucuk'), dugme('↻', () => ciz(), M.yeniden_yukle, 'bs-kar__cikar'));
      y.append(dugme('×', () => cikar(h), M.cikar_ad.replace('{ad}', p?.title || M.saat), 'bs-kar__cikar'));
    });
    if (sayfa) tablo(urunler);
    sonuclar.querySelectorAll('button[data-handle]').forEach((b) => { b.disabled = secili.includes(b.dataset.handle); });
    document.querySelectorAll('[data-compare-add]').forEach((b) => b.setAttribute('aria-pressed', String(secili.includes(b.dataset.compareAdd))));
  };
  const ac = (tetik) => { acan = tetik; if (!pencere.open) pencere.showModal(); };
  document.addEventListener('click', (e) => {
    const ekleD = e.target.closest('[data-compare-add]');
    const acD = e.target.closest('[data-compare-open]');
    if (ekleD) { e.preventDefault(); ac(ekleD); ekle(ekleD.dataset.compareAdd); } else if (acD) ac(acD);
  });
  kok.querySelector('[data-compare-close]').addEventListener('click', () => pencere.close());
  pencere.addEventListener('close', () => { aramaKontrol?.abort(); clearTimeout(zamanlayici); acan?.focus(); });
  pencere.addEventListener('click', (e) => {
    if (e.target !== pencere) return;
    const r = pencere.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) pencere.close();
  });
  kok.querySelector('[data-compare-clear]').addEventListener('click', () => { secili = []; kaydet(); ciz(); durum.textContent = M.temizlendi; });
  girdi.addEventListener('input', () => {
    clearTimeout(zamanlayici); aramaKontrol?.abort();
    const q = girdi.value.trim();
    sonuclar.replaceChildren();
    if (q.length < 2) { durum.textContent = M.en_az_karakter; return; }
    durum.textContent = M.araniyor;
    zamanlayici = setTimeout(async () => {
      aramaKontrol = new AbortController();
      try {
        const sorgu = new URLSearchParams({ q, type: 'product', view: 'bs-karsilastir-veri', 'options[prefix]': 'last' });
        const r = await fetch(`${ara}?${sorgu}`, { signal: aramaKontrol.signal });
        if (!r.ok) throw Error('arama');
        const veri = await r.json();
        if (girdi.value.trim() !== q) return;
        sonuclar.replaceChildren();
        (veri.products || []).forEach((p) => {
          if (!gecerli(p.handle)) return;
          zenginlestir(p); onbellek.set(p.handle, p);
          const b = dugme('', () => ekle(p.handle), null, 'bs-kar__sonuc');
          b.dataset.handle = p.handle; b.disabled = secili.includes(p.handle);
          const metin = el('span', p.title); metin.append(el('small', p.price));
          b.append(gorsel(p), metin, el('span', '+', 'bs-kar__arti'));
          sonuclar.append(b);
        });
        durum.textContent = veri.products?.length ? M.secin : M.bulunamadi;
      } catch (err) { if (err.name !== 'AbortError') durum.textContent = M.arama_hatasi; }
    }, 300);
  });
  sayfa?.querySelector('[data-compare-diff]').addEventListener('change', farklar);
  window.addEventListener('storage', (e) => { if (e.key !== ANAHTAR) return; try { secili = temizle(JSON.parse(e.newValue || '[]')); ciz(); } catch { /* mevcut seçim kalır */ } });
  if (sayfa) kaydet();
  ciz();
})();
